module.exports = __webpack_public_path__ + "img/about_banner_btn.db0c91e6.png";